import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  width: 900px;
  height: 700px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 30px 20px;

  input {
  }

  label {
    margin-right: 20px;
  }
`;

export const Gap = styled.div`
  flex: 1;
`;
